import { lazy, Suspense } from 'react';
import { LazyAssetsFallback, type LazyAssetProps } from '@frontend/internal-assets';

const LazyDigitalFormsSampleMultiColumnSvg = lazy(
  () => import('./svg-components/digital-formssample-multi-column-svg')
);

const DigitalFormsSampleMultiColumnSvg = ({ assetsFallbackProps = {}, customFallback, ...rest }: LazyAssetProps) => (
  <Suspense fallback={customFallback || <LazyAssetsFallback {...assetsFallbackProps} />}>
    <LazyDigitalFormsSampleMultiColumnSvg {...rest} />
  </Suspense>
);

export default DigitalFormsSampleMultiColumnSvg;
